import { render, staticRenderFns } from "./firewall-customer.vue?vue&type=template&id=0cf52f90&"
import script from "./firewall-customer.vue?vue&type=script&lang=js&"
export * from "./firewall-customer.vue?vue&type=script&lang=js&"
import style0 from "./firewall-customer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports